import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../AuthContext";

export const ProtectedLayout = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div>
      <Outlet />
    </div>
  )
};
